module.exports = __webpack_public_path__ + "img/shop.eb64f514.svg";